export type StatusTone = 'neutral' | 'info' | 'success' | 'warning' | 'danger' | 'brand';

export const orderStatusTone = {
  PENDING: 'warning',
  CONFIRMED: 'info',
  DISPATCH_REQUESTED: 'info',
  DISPATCHED: 'brand',
  IN_TRANSIT: 'brand',
  OUT_FOR_DELIVERY: 'brand',
  DELIVERED: 'success',
  DELIVERY_FAILED: 'warning',
  RETURNING: 'warning',
  RETURNED: 'neutral',
  RETURN_RECEIVED: 'info',
  RETURN_REQUESTED: 'warning',
  CANCELED: 'neutral',
} as const satisfies Record<string, StatusTone>;

export const paymentStatusTone = {
  COD_PENDING: 'warning',
  COD_COLLECTED: 'info',
  SETTLED: 'success',
  DISPUTED: 'danger',
  REFUND_PENDING: 'warning',
  REFUNDED: 'neutral',
  VOID: 'neutral',
} as const satisfies Record<string, StatusTone>;

export const shipmentStatusTone = {
  CREATED: 'info',
  PICKED_UP: 'brand',
  IN_TRANSIT: 'brand',
  AT_HUB: 'brand',
  OUT_FOR_DELIVERY: 'brand',
  DELIVERED: 'success',
  DELIVERY_FAILED: 'warning',
  RETURNING: 'warning',
  RETURNED: 'neutral',
  CANCELED: 'neutral',
  LOST: 'danger',
  UNKNOWN: 'neutral',
} as const satisfies Record<string, StatusTone>;

export const remittanceOutcomeTone = {
  settled: 'success',
  return_fee: 'info',
  disputed: 'danger',
  duplicate: 'neutral',
  not_delivered: 'warning',
  unknown: 'warning',
  wrong_carrier: 'warning',
} as const satisfies Record<string, StatusTone>;

export const settlementStatusTone = {
  settled: 'success',
  disputed: 'danger',
  resolved: 'info',
} as const satisfies Record<string, StatusTone>;

export const carrierStatusTone = {
  Enlevé: 'brand',
  'Au Dépôt': 'brand',
  'En Cours de Livraison': 'brand',
  'Anomalie de Livraison': 'warning',
  "Anomalie d'Enlévement": 'warning',
  Livré: 'success',
  'Livré Payé': 'success',
  'Echange Reçu': 'success',
  'Retour Dépôt': 'warning',
  'Retour Client Agence': 'warning',
  'Retour Définitif': 'warning',
  'Retour Expéditeur': 'warning',
  'Retour Reçu': 'neutral',
} as const satisfies Record<string, StatusTone>;

export const toneFor = (map: Record<string, StatusTone>, status: string): StatusTone =>
  map[status] ?? 'neutral';

export const stockHealthTone = { ok: 'success', low: 'warning', out: 'danger' } as const satisfies Record<
  string,
  StatusTone
>;

export type StockHealth = keyof typeof stockHealthTone;

export const memberStatusTone = {
  active: 'success',
  pending: 'warning',
  paused: 'neutral',
} as const satisfies Record<string, StatusTone>;
